export default __webpack_public_path__ + "static/media/job.09f8dbd3.svg";